import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import PromoBanner from "@/components/PromoBanner";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import LegalPage from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/#")) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen bg-cream text-onyx">
          <PromoBanner />
          <Navbar />
          <CartDrawer />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/produit" element={<ProductPage />} />
              <Route path="/produit/:slug" element={<ProductPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment/success" element={<Success />} />
              <Route path="/payment/cancel" element={<Cancel />} />
              <Route path="/legal" element={<LegalPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
